// Polyfills
import 'babel-polyfill'
import 'whatwg-fetch'
import Promise from 'promise-polyfill'
import cssVars from 'css-vars-ponyfill'

// App
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { createStore } from './store'
import './registerServiceWorker'
import $script from 'scriptjs'
import forIn from 'lodash/forIn'

// Plugins
import { i18n } from '@/plugins/i18n'
import '@/plugins'

import Platform from '@/plugin-platforms'
import { createProvider } from './vue-apollo'

// Add polyfills to window
if (!window.Promise) {
  window.Promise = Promise
}

// Load Vorlon for debugging
// if (process.env.NODE_ENV === 'development' && process.env.VUE_APP_PLATFORM !== 'web') {
//   require('./debug')
// }

// Load non-moduled js
$script(`${process.env.BASE_URL}polyfills/flexibility.js`, () => {
  console.log('flexibility.js Loaded!')
})

Vue.config.productionTip = false

export const store = createStore()
export const apolloProvider = createProvider()

new Vue({
  router,
  store,
  i18n,
  apolloProvider,
  render: h => h(App)
}).$mount('#app')

const loadPlugin = async () => {
  await store.dispatch('settings/load')

  // If it's been 7 days since installation then ask user to login
  if (!store.getters['user/get']) {
    router.replace({
      name: 'login'
    })
  } else {
    // In Abstract Router Mode, we've to push index path to the router
    router.replace({
      name: `${store.state.settings.asset}s-slug`,
      query: {
        sort: 'latest'
      }
    })
  }
}

// Platform Variables Receive
// window.onReceivePlatformVariables = (data) => {
//   store.commit('platform/set', data)
// }

// Sketch Specific Coding
if (Platform.platform === 'sketch') {
  window.sketchReplaceDroppedImage = (name) => {
    const item = store.state.platform.drag.item

    if (item) {
      store.commit('platform/setLog', item)
      Platform.insertItem({
        ...item.file,
        force: false,
        replace: true
      })
      store.commit('platform/setDragItem', null)
    } else {
      // store.commit('platform/setLog', 'no item')
    }
  }
}

// Check for Updates
if (process.env.VUE_APP_VERSIONING) {
  store.dispatch('platform/checkForUpdates')
}

// If LocalStorage is supported then use it
// Else this `window` function will receive the data from Host
if (Platform.features.localStorage === false) {
  // Add Global EventListener that sets data to the store
  window.onReceivePluginSettings = (data) => {
    console.log('Settings Received', data)
    forIn(data, (value, key) => {
      let json = Platform.storage.parseJSON(value)
      Platform.storage.putJSON(key, json)
    })

    loadPlugin()
  }
} else {
  // Retrive Stored Data to Store
  loadPlugin()
}

// Platform Sync Supported
if (Platform.features.syncFromTool) {
  window.onComponentsSynced = (data) => {
    // Set log
    // store.commit('platform/set', {
    //   log: 'synced: ' + JSON.stringify(data)
    // })
    const FOLDERS_SHOW = require('@/graphql/FoldersShow.gql')

    // Refresh Folder Details
    apolloProvider.defaultClient.query({
      query: FOLDERS_SHOW,
      variables: {
        uuid: data.uuid,
        permissions: true
      },
      fetchPolicy: 'network-only'
    })
  }
}

// Add to Window Object
window.store = store
window.router = router
window.loadPlugin = loadPlugin

// CSS Variables Polyfill
cssVars()
